import script from "./MoreDiscounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreDiscounts.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__